import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import {
  CopytradeHistory,
  CopytradeHistoryRequest,
  CopytradeHistoryResponse,
} from './types'
import { $params } from '../../../../features/router'
import { RequestError } from '../../../../shared/errorResponse'

export const copytradeHistoryMounted = createEvent<CopytradeHistoryRequest>()

export const setCopytradeHistoryRequestError = createEvent<RequestError>()

export const getCopytradeHistory = fx<
  CopytradeHistoryRequest,
  CopytradeHistoryResponse
>({
  method: 'GET',
  url: '/strategy_subscription',
})

export const $copytradeHistory = restore<CopytradeHistory[]>(
  getCopytradeHistory.doneData.map((doneData) => doneData.body.items),
  [],
)

export const $totalCountOfCopytradeHistory = restore(
  getCopytradeHistory.doneData.map((a) => a.body.total),
  0,
)

export const $errorCopytradeHistoryRequest = restore(
  setCopytradeHistoryRequestError,
  {
    message: '',
    code: 0,
  },
)

sample({
  clock: copytradeHistoryMounted,
  fn: ({ limit, page, filters }) => {
    const { clientID } = $params.getState() ?? {}

    return {
      url: '/strategy_subscription',
      query: {
        limit: String(limit),
        page: String(page),
        order: '-startedAt',
        where: JSON.stringify({
          clientId: clientID,
          ...(filters ?? {}),
        }),
        populate: JSON.stringify([
          'StrategySubscription.account',
          'StrategySubscription.strategy',
          'Strategy.account',
        ]),
      },
    }
  },
  target: getCopytradeHistory,
})

sample({
  clock: getCopytradeHistory.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setCopytradeHistoryRequestError],
})
